import './Switch.scss';
import React, { FC, ChangeEventHandler, ReactNode } from 'react';
import Icon from '@/components/extra/Icon/Icon';
import type { IconType } from '@/components/extra/Icon/Icon';
import classNames from 'classnames';

type SwitchProps = {
    children: ReactNode;
    rightLabel?: ReactNode | string;
    icon?: IconType;
    labelFixedGap?: boolean;
    inline?: boolean;
    checked?: boolean;
    disabled?: boolean;
    addBottomGap?: boolean;
    className?: string;
    baseSize?: number;
    onChange?: ChangeEventHandler<HTMLInputElement>;
};

const Switch: FC<SwitchProps> = ({
    children,
    icon,
    labelFixedGap,
    rightLabel,
    inline,
    checked,
    disabled,
    addBottomGap,
    className,
    onChange,
}) => {
    return (
        <label
            className={classNames('Switch', className, {
                'Switch-fixed': labelFixedGap,
                'Switch-inline': inline,
                'Switch-hasBottomGap': addBottomGap,
            })}
        >
            <input
                className="Switch_input invisible"
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={onChange}
            />
            <span
                className={classNames('Switch_label', {
                    'Switch_label-disabled': disabled,
                })}
            >
                {icon && <Icon icon={icon} className="Switch_icon" />}
                {children}
            </span>
            <div className="Switch_switch"></div>
            {rightLabel && (
                <span
                    className={classNames('Switch_label', {
                        'Switch_label-disabled': disabled,
                    })}
                >
                    {rightLabel}
                </span>
            )}
        </label>
    );
};

export default Switch;
